import { normalizePassageText } from '../utils/passageText';

/**
 * Passage word count validation constants.
 *
 * Defaults are used until the server-side settings are fetched.
 * Actual values come from /api/settings/public and are stored
 * in the passageLimits store (see stores/passageLimits.ts).
 */

export const DEFAULT_PASSAGE_MIN_WORDS = 50;
export const DEFAULT_PASSAGE_MAX_WORDS = 1000;

/** Maximum number of passages a user can create */
export const MAX_PASSAGES_COUNT = 1000;

/** Count English words in a passage text. */
export function countPassageWords(text: string): number {
  return normalizePassageText(text).trim().split(/\s+/).filter(Boolean).length;
}
